<template>
  <div v-if="shouldShowProfile" class="py-3">
    <div v-for="(group, idx) in profile.customer_profile" class="detail mb-3" :key="idx">
      <div class="detail__wrapper">
        <div v-for="(field, index2) in group.member_fields" :key="'field' + index2" class="detail__item full">
          <div class="detail__title">{{ field.title }}</div>
          <div class="detail__value">
            {{ getFieldDisplayValue(field) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerProfile",
  props: {
    profile: {
      type: Object,
      default: null
    },
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    shouldShowProfile() {
      return this.profile && this.profile.show_customer_profile;
    }
  },
  methods: {
    getFieldDisplayValue(field) {
      if (field.matched_key.includes("extra."))
        return this.user.extra[field.matched_key.replace("extra.", "")];
      else
        return this.user[field.matched_key];
    }
  }
};
</script>

<style lang="scss" scoped>
.detail {
  background: #ffffff;
  margin-bottom: 1px;
  border-radius: 10px;
  border: solid 1px #e5e5ea;
  padding: 12px;

  &__row {
    display: flex;

    &:not(:last-of-type) {
      margin-bottom: 20px;
    }
  }

  &__wrapper {
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
  }

  &__item {
    border-right: solid 1px #e5e5ea;
    border-bottom: solid 1px #e5e5ea;
    min-width: 50%;
    flex: 1 1 auto;
    margin: 0 -1px -1px 0;
    padding: 6px 12px;

    &.full {
      width: 100%;
    }
  }

  &__title {
    font-weight: 400;
    font-size: 14px;
    color: #636366;
  }

  &__value {
    font-weight: 600;
    font-size: 18px;
    color: #2c2c2e;
  }

  &__value--empty {
    font-weight: 400;
    font-size: 16px;
    color: #b7b7b7;
  }

  .is-flex & {
    margin-bottom: 8px;
  }
}
</style>
